import {
  createBrowserRouter,
  createHashRouter,
  Navigate,
  RouteObject,
} from "react-router-dom"
import App from "./layout/App"
import Landingpage from "../pages/landingpage/Landingpage"
import InquiryPage from "../pages/inquiry/InquiryPage"
import NotFound from "./errors/NotFound"
import ThanksPage from "../pages/inquiry/ThanksPage"

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <App />,
    children: [
      { path: "landingpage", element: <Landingpage /> },
      { path: "inquiry", element: <InquiryPage /> },
      { path: "inquiry/complete", element: <ThanksPage /> },
      { path: "not-found", element: <NotFound /> },
      { path: "*", element: <Navigate replace to="/not-found" /> },
    ],
  },
]

// export const router = createBrowserRouter(routes)
export const router = createHashRouter(routes)
